import axios from "./axios";

// Fillable document templates & forms
// Backend: /api/v1/document_forms/*

export async function fetchDocumentFormCategories(params = {}) {
  return axios({ method: "get", url: "/document_forms/categories", params })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function createDocumentFormCategory(payload) {
  return axios({
    method: "post",
    url: "/document_forms/categories",
    data: { document_form_template_category: payload },
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function updateDocumentFormCategory(id, payload) {
  return axios({
    method: "put",
    url: `/document_forms/categories/${id}`,
    data: { document_form_template_category: payload },
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function fetchDocumentFormTemplates(params = {}) {
  return axios({ method: "get", url: "/document_forms/templates", params })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function fetchDocumentFormTemplate(id) {
  return axios({ method: "get", url: `/document_forms/templates/${id}` })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function fetchDocumentFormTemplatePdf(id) {
  return axios({ method: "get", url: `/document_forms/templates/${id}/pdf` })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function createDocumentFormTemplate(payload) {
  return axios({
    method: "post",
    url: "/document_forms/templates",
    data: { document_form_template: payload },
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function updateDocumentFormTemplate(id, payload) {
  return axios({
    method: "put",
    url: `/document_forms/templates/${id}`,
    data: { document_form_template: payload },
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function deleteDocumentFormTemplate(id) {
  return axios({ method: "delete", url: `/document_forms/templates/${id}` })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function registerDocumentFormTemplateHse(id, payload = {}) {
  return axios({
    method: "post",
    url: `/document_forms/templates/${id}/register_hse_document`,
    data: payload,
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function fetchDocumentForms(params = {}) {
  return axios({ method: "get", url: "/document_forms/forms", params })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function fetchDocumentFormsArchive(params = {}) {
  return axios({ method: "get", url: "/document_forms/forms/archive", params })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function fetchDocumentForm(id) {
  return axios({ method: "get", url: `/document_forms/forms/${id}` })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function createDocumentForm(payload) {
  return axios({
    method: "post",
    url: "/document_forms/forms",
    data: {
      document_form: payload,
      document_form_template_id: payload?.document_form_template_id,
    },
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function updateDocumentForm(id, payload) {
  return axios({
    method: "put",
    url: `/document_forms/forms/${id}`,
    data: { document_form: payload },
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function deleteDocumentForm(id) {
  return axios({ method: "delete", url: `/document_forms/forms/${id}` })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

export async function fetchDocumentFormPdf(id, { signature = false } = {}) {
  return axios({
    method: "get",
    url: `/document_forms/forms/${id}/pdf`,
    params: { signature },
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}
